<template>
	<div class="page-container">
		<!-- 查询区域 -->
		<el-card class="query-card" shadow="hover">
			<div class="search-wrapper">
				<el-input 
					v-model="address" 
					type="textarea" 
					:rows="2"
					placeholder="请输入收件地址，例如：海南省海口市美兰区国兴大道9号" 
					resize="none"
					class="address-input"
					@keyup.enter="handleQuery"
				/>
				<el-button 
					type="primary" 
					@click="handleQuery" 
					:loading="loading"
					class="search-btn"
				>
					<el-icon style="margin-right: 4px;"><Search /></el-icon>
					查询
				</el-button>
			</div>
		</el-card>

		<!-- 结果区域 -->
		<el-card class="result-card" shadow="never" v-loading="loading">
			<template #header>
				<div class="card-header">
					<span>查询结果</span>
					<el-tag type="info" effect="plain" v-if="dataList.length > 0">共 {{ dataList.length }} 家</el-tag>
				</div>
			</template>
			
			<el-table 
				:data="dataList" 
				stripe 
				border 
				style="width: 100%"
				:row-class-name="rowStatusClass"
				empty-text="暂无数据，请输入地址查询"
			>
				<el-table-column prop="name" label="快递公司" width="240">
					<template #default="scope">
						<div class="express-info">
							<el-image 
								class="express-logo"
								:src="global.expressLogoUrl + scope.row.code + '.png'" 
								fit="contain"
							>
								<template #error>
									<div class="image-slot">
										<el-icon><Picture /></el-icon>
									</div>
								</template>
							</el-image>
							<span class="express-name">{{ scope.row.name }}</span>
						</div>
					</template>
				</el-table-column>
				
				<el-table-column prop="statusText" label="可达情况" width="120" align="center">
					<template #default="scope">
						<el-tag :type="scope.row.status ? 'success' : 'danger'" effect="light" round size="small">
							{{ scope.row.statusText }}
						</el-tag>
					</template>
				</el-table-column>
				
				<el-table-column prop="describe" label="不可达原因/备注">
					<template #default="scope">
						<span class="desc-text" :class="{ 'unreachable': !scope.row.status }">
							{{ scope.row.describe || '-' }}
						</span>
					</template>
				</el-table-column>
			</el-table>
		</el-card>
	</div>
</template>

<script>
	import { Search, Picture } from '@element-plus/icons-vue';

	export default {
		components: { Search, Picture },
		data() {
			return {
				loading: false,
				address: "",
				dataList: []
			}
		},
		methods: {
			rowStatusClass({ row }) {
				return row.status ? 'success-row' : 'warning-row';
			},
			handleQuery() {
				if (!this.address.trim()) {
					this.$message.warning('请输入收件地址');
					return;
				}
				this.query(this.address);
			},
			query(address) {
				this.loading = true;
				this.dataList = [];
				
				this.apiService.post({
						modules: "stop",
						content: {
							cpCode: ['ZTO', 'YTO', 'STO', 'YD', 'JT', 'SF', 'JDL', 'POST'],
							text: address
						}
					})
					.then((res) => {
						if (res.status) {
							this.dataList = res.data.list || [];
						} else {
							this.$message.error(res.msg || '查询失败');
						}
					})
					.finally(() => {
						this.loading = false;
					});
			}
		}
	}
</script>

<style scoped lang="scss">
	.page-container {
		padding: 20px;
		background-color: #f5f7fa;
		min-height: 100vh;
	}

	.query-card {
		margin-bottom: 20px;
		
		.search-wrapper {
			display: flex;
			align-items: center;
			gap: 15px;
			max-width: 800px; /* 限制最大宽度，避免太长 */
			
			.address-input {
				flex: 1;
			}
			
			.search-btn {
				/* 移除之前的高度强制，保持自然高度 */
				height: auto; 
				padding: 8px 20px;
			}
		}
	}

	.result-card {
		.card-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-weight: bold;
			font-size: 14px;
		}
	}

	.express-info {
		display: flex;
		align-items: center;
		
		.express-logo {
			width: 24px; /* 稍微缩小 logo */
			height: 24px;
			border-radius: 50%;
			margin-right: 8px;
			background-color: #f5f7fa;
			border: 1px solid #ebeef5;
			
			.image-slot {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 100%;
				height: 100%;
				color: #909399;
				font-size: 12px;
			}
		}
		
		.express-name {
			font-size: 14px;
			color: #303133;
		}
	}

	.desc-text {
		font-size: 13px;
		color: #606266;
		
		&.unreachable {
			color: #f56c6c;
		}
	}

	:deep(.el-table__row) {
		&.success-row {
			background-color: #fff !important;
		}
		&.warning-row {
			background-color: #fff !important;
		}
	}
</style>